import { useEffect, useRef } from 'react';
import { Button } from 'react-aria-components';

import type { ContextMenuState } from '../app/types';

export function ContextMenu({ menu, onClose }: { menu: ContextMenuState; onClose: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const close = () => onClose();
    window.addEventListener('pointerdown', close);
    window.addEventListener('blur', close);
    ref.current?.focus();
    return () => { window.removeEventListener('pointerdown', close); window.removeEventListener('blur', close); };
  }, [onClose]);
  const width = 230;
  const height = menu.actions.length * 38 + 16;
  const x = Math.min(menu.x, window.innerWidth - width - 8);
  const y = Math.min(menu.y, window.innerHeight - height - 8);
  return (
    <div ref={ref} className="context-menu" role="menu" tabIndex={-1} style={{ left: Math.max(8, x), top: Math.max(8, y) }} onPointerDown={event => event.stopPropagation()}>
      {menu.actions.map(action => action.separator ? <div key={action.id} className="menu-separator" /> : (
        <Button key={action.id} className={action.danger ? 'danger' : ''} isDisabled={action.disabled} onPress={() => { action.run(); onClose(); }}>
          {action.icon && <action.icon />}<span>{action.label}</span>
        </Button>
      ))}
    </div>
  );
}
